module.exports = __webpack_public_path__ + "static/media/united-kingdom.7f990640.svg";